import {
  takeEvery, put, select, call,
} from 'redux-saga/effects'
import { push } from 'connected-react-router'
import cookie from 'react-cookies'
import qs from 'query-string'
import { getRouterLocation, getRouterUrl } from '@/store/selectors/router'
import { getClient } from '@/store/selectors/socket'
import { SIGN_IN_URL } from '@/constants/routes'
import { USER_REFRESH_TOKEN } from '@/store/actions/user'
import { connectToSocket } from '@/store/actions/socket'
import {
  successUserRefreshToken,
  errorUserRefreshToken,
} from '@/store/actions/user/refreshToken'
import { ACCESS_TOKEN_COOKIE } from '@/constants/names'
import { SERVER_URL } from '@/constants/socket'
import createNotifications from '@/helpers/notification'
import { refreshAccessToken } from '@/helpers/axios/refreshAccessToken'

export function* redirectToLoginPage() {
  try {
    const url = yield select(getRouterUrl)
    const { search } = yield select(getRouterLocation)
    const queryObject = qs.parse(search)
    const encodedUrl = encodeURIComponent(url)
    cookie.remove(ACCESS_TOKEN_COOKIE, { path: '/' })
    if (!queryObject.redirect) {
      yield put(push({
        pathname: SIGN_IN_URL,
        search: qs.stringify({ redirect: encodedUrl }),
      }))
    }
  } catch (error) {
    console.log('TCL: function*redirectToLoginPage -> error', error)
    const toast = createNotifications()
    toast({
      title: 'Ошибка операции!',
      description: 'Повторите попытку позже.',
      type: 'error',
    })
  }
}

function* disconnectSocket(client) {
  if (client && client.disconnect) {
    client.disconnect()
  }
}

function* validateRefresh({ payload: { redirect } }) {
  const client = yield select(getClient)

  try {
    if (redirect) {
      yield disconnectSocket(client)
      yield redirectToLoginPage()
      yield put(successUserRefreshToken())
      return null
    }

    let accessToken = cookie.load(ACCESS_TOKEN_COOKIE)
    if (!accessToken) {
      try {
        const data = yield call(refreshAccessToken)
        accessToken = data?.access_token || cookie.load(ACCESS_TOKEN_COOKIE)
      } catch (error) {
        yield disconnectSocket(client)
        yield redirectToLoginPage()
        yield put(errorUserRefreshToken(error))
        return null
      }
    }

    if (accessToken) {
      yield put(connectToSocket({
        url: SERVER_URL,
        token: accessToken,
      }))
    }

    yield put(successUserRefreshToken())
    return null
  } catch (error) {
    yield disconnectSocket(client)
    yield redirectToLoginPage()
    yield put(errorUserRefreshToken(error))
    return null
  }
}

export default function* root() {
  yield takeEvery(USER_REFRESH_TOKEN.REQUEST, validateRefresh)
}
